export enum FireOpenPaymentStatusEnum {
  PAID = 'PAID',
  ACTIVE = 'ACTIVE',
  AUTHORISED = 'AUTHORISED',
  REMOVED = 'REMOVED',
  EXPIRED = 'EXPIRED',
  REFUNDED = 'REFUNDED',
  PENDING = 'PENDING'
}
